import { Season, SeasonFormDefault } from "api";
import { createContext } from "react";

const SeasonContext = createContext<Season>({
    ...SeasonFormDefault,
});

export { SeasonContext };
